import sentryService from '../services/SentryService'

// Refer to https://developers.arcgis.com/rest/geocode/api-reference/geocoding-category-filtering.htm
// for complete documentation about category filtering

const BASE_URL = 'https://geocode.arcgis.com/arcgis/rest/services/World'

const request = async (url: string) => {
  try {
    const res = await fetch(`${BASE_URL}${url}`)
    return res.json()
  } catch (error) {
    sentryService.captureError(error as Error, {
      tags: {
        errorType: 'geocoding',
        service: 'arcgis',
      },
      extra: {
        url: `${BASE_URL}${url}`,
      },
    })
    throw error
  }
}

export const suggest = async (query: string, maxSuggestions = 5) => {
  const url = `/GeocodeServer/suggest?f=json&text=${encodeURIComponent(query)}&maxSuggestions=${maxSuggestions}`
  const result = await request(url)

  if (result?.error) {
    const err = new Error(result.error?.message ?? 'ArcGIS suggest returned an error payload')
    sentryService.captureError(err, {
      tags: { errorType: 'geocoding', service: 'arcgis' },
      extra: { url: `${BASE_URL}${url}`, arcgisError: result.error },
    })
    throw err
  }

  if (!Array.isArray(result?.suggestions)) {
    const err = new Error('ArcGIS suggest returned a malformed payload')
    sentryService.captureError(err, {
      tags: { errorType: 'geocoding', service: 'arcgis' },
      extra: { url: `${BASE_URL}${url}` },
    })
    throw err
  }

  return result
}

export const geocode = async (magicKey: string) => {
  const url = `/GeocodeServer/findAddressCandidates?f=json&outFields=*&magicKey=${encodeURIComponent(magicKey)}`
  return await request(url)
}

export const reverseGeocode = async (latitude: string, longitude: string, featureTypes = []) => {
  const url = `/GeocodeServer/reverseGeocode?f=json&featureTypes=${encodeURIComponent(
    featureTypes.join(','),
  )}&location=${encodeURIComponent(longitude)},${encodeURIComponent(latitude)}&outFields=*`
  return await request(url)
}
